import { render, staticRenderFns } from "./ModalPolicyInstallmentHistory.vue?vue&type=template&id=84f8d1ce&scoped=true"
import script from "./ModalPolicyInstallmentHistory.vue?vue&type=script&lang=js"
export * from "./ModalPolicyInstallmentHistory.vue?vue&type=script&lang=js"
import style0 from "./ModalPolicyInstallmentHistory.vue?vue&type=style&index=0&id=84f8d1ce&prod&scoped=true&lang=scss"
import style1 from "./ModalPolicyInstallmentHistory.vue?vue&type=style&index=1&id=84f8d1ce&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84f8d1ce",
  null
  
)

export default component.exports